import { TextField, InputAdornment, Link, IconButton, Stack, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LoadingButton from '@mui/lab/LoadingButton';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { PATH_AUTH } from '../../../router/paths';
import { handleLogin } from '../../../redux/slices/auth';
import FacebookLoginForm from './FacebookLoginForm';
import GoogleLoginForm from './GoogleLoginForm';
import TelegramLogin from './TelegramLogin';
import TikTokLogin from './TikTokLogin';

function LoginForm(_props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await handleLogin({ email, password });
      setLoading(false);
    } catch (error) {
      console.log('🚀 ~ handleSubmit ~ error:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      setEmail('');
      setPassword('');
      setLoading(false);
    };
  }, []);
  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <Stack spacing={2}>
      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField
            fullWidth
            required
            type={'email'}
            label={'Email address'}
            autoComplete="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <TextField
            fullWidth
            required
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleShowPassword} edge="end">
                      {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            sx={{
              borderRadius: '100px',
            }}
            loading={loading}
          >
            Login
          </LoadingButton>
        </Stack>
      </form>

      {/* <TikTokLogin /> */}
      <GoogleLoginForm />
      {/* <FacebookLoginForm /> */}
      <TelegramLogin />
      <Stack direction="row" sx={{ pt: 0.5 }} alignItems="center" justifyContent="space-between">
        <Link component={RouterLink} variant="subtitle2" to={PATH_AUTH.register}>
          Create new account
        </Link>

        <Link component={RouterLink} variant="subtitle2" to={`${PATH_AUTH.forgotPassword}?email=${email}`}>
          Forgot password?
        </Link>
      </Stack>
    </Stack>
  );
}

export default LoginForm;
